import Result from '../Interface/Result';
import { BaseService } from "../services/BaseService";
import { IPageContent } from '../Interface/IPageContent'
import { IMainMenu } from '../Interface/IMainMenu';
import { ISubMenu } from '../Interface/ISubMenu';
import { IDropdownValues } from '../Interface/IDropdownValues';
import { IAdminLogin } from '../Interface/IAdminLogin';
import { IHomeSlider } from '../Interface/IHomeSlider';
import { IUpdatedPageContent } from '../Interface/IUpdatedPageContent';
import { IAPIResponse } from '../Interface/IAPIResponse';
import { IReligiousEventSlider } from '../Interface/ReligiousEventSlider';
import configuration from '../assets/config.json';
import { ISpecialEvents } from '../Interface/ISpecialEvents';
import { IUser } from '../Interface/IUser';
import { GetCookie } from '../Utils/AppFunc';
import { ResultStatus } from '../Utils/Enum';
import { IServiceBooking } from '../Interface/IServiceBooking';
import { IEventRegistration } from '../Interface/IEventRegistration';
import { IIndividualSamskaras } from '../Interface/IIndividualSamskaras';
import { IServiceMaterials } from '../Interface/IServiceMaterials';
import { ITempleTimes } from '../Interface/ITempleTimes';
import { IHomePageContent } from '../Interface/IHomePageContent';
import { IFacilityRequired } from '../Interface/IFacilityRequired';
import { ITempleServicesContent } from '../Interface/ITempleServicesContent';
import { IUpcommingAndCompletedServices } from '../Interface/IUpcommingAndCompletedServices';
import { IDeity } from '../Interface/IDeity';
import { IPriest } from '../Interface/IPriest';
import { IDevoteeRegistration } from '../Interface/IDevoteeRegistration';
import { IBoardMembers } from '../Interface/IBoardMembers';
import { IDevoteeFeedback } from '../Interface/IDevoteeFeedback';
import { IProjectList } from '../Interface/IProjectList';
import { IProjectsAndAchievements } from '../Interface/IProjectsAndAchievements';
import { IAdminService } from '../Interface/IAdminService';
import { ICalendar } from '../Interface/ICalendar';
import { IStateData } from '../Interface/IStateData';


export default class AdminService extends BaseService {
    public static async GetLoggedInUser(): Promise<Result<IUser>> {
        var loggedInUser = GetCookie("user");
        if (loggedInUser != "") {
            if (typeof (Storage) !== "undefined") {
                var userData = localStorage.getItem("user");
                if (userData != null && userData != undefined) {
                    var user = JSON.parse(localStorage.getItem("user"));
                    return new Result(user, ResultStatus.Success);
                }
            }
        }
        else {
            // Remove Cookie
            document.cookie = "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC;"
        }
        return null;
    }

    public static async CheckUserSession() {


    }



    public static async UserLogOut(): Promise<Result<IUser>> {
        // Remove Cookie
        document.cookie = "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
        if (typeof (Storage) !== "undefined") {
            var userData = localStorage.getItem("user");
            if (userData != null && userData != undefined) {
                localStorage.removeItem("user");
                let data: IUser = null;
                return new Result(data, ResultStatus.Success);
            }
        }
    }

    public static async UpdatePageContent(updatedData: IUpdatedPageContent): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/UpdatePageContent`,
            method: "PUT",
            data: updatedData
        });
        return result;
    }

    public static async GetPageContent(PageName, ContentGroup): Promise<Result<Array<IPageContent>>> {
        var result = await this.requestJson<Array<IPageContent>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetPageContent?PageName=` + PageName + '&ContentGroup=' + ContentGroup,
            method: "GET"
        });
        return result;
    }

    public static async GetMainMenu(): Promise<Result<Array<IMainMenu>>> {
        var result = await this.requestJson<Array<IMainMenu>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetMainMenu`,
            method: "GET"
        });
        return result;
    }

    public static async GetSubMenu(): Promise<Result<Array<ISubMenu>>> {
        var result = await this.requestJson<Array<ISubMenu>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetSubMenu`,
            method: "GET"
        });
        return result;
    }

    public static async GetDropdownValues(ControlName): Promise<Result<Array<IDropdownValues>>> {
        var result = await this.requestJson<Array<IDropdownValues>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetDropdownValues?ControlName=` + ControlName,
            method: "GET"
        });
        return result;
    }

    public static async AdminLogin(userName: string, password: string): Promise<Result<IAdminLogin>> {
        var result = await this.requestJson<IAdminLogin>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/AdminLogin?userName=` + userName + `&password=` + password,
            method: "GET"
        });
        return result;
    }


    public static async GetImageSliderValues(sliderName): Promise<Result<Array<IHomeSlider>>> {
        var result = await this.requestJson<Array<IHomeSlider>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetImageSliderValues?sliderName=` + sliderName,
            method: "GET"
        });
        return result;
    }
    public static async GetReligiousEventSlider(sliderName): Promise<Result<Array<IReligiousEventSlider>>> {
        var result = await this.requestJson<Array<IReligiousEventSlider>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetReligiousEventSlider?sliderName=` + sliderName,
            method: "GET"
        });
        return result;
    }
    public static async GetSpecialEvents(eventType): Promise<Result<Array<ISpecialEvents>>> {
        var result = await this.requestJson<Array<ISpecialEvents>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetSpecialEvents?eventType=` + eventType,
            method: "GET"
        });
        return result;
    }

    public static async RegisterUser(user: IUser): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/AddOrUpdateUser`,
            method: "PUT",
            data: user
        });
        return result;
    }

    public static async GetUser(phone, email): Promise<Result<IUser>> {
        var result = await this.requestJson<IUser>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetUser?phone=` + phone + `&email=` + email,
            method: "GET"
        });
        return result;
    }

    public static async GetServiceBookingDropdowns(DropdownFor): Promise<Result<Array<IDropdownValues>>> {
        var result = await this.requestJson<Array<IDropdownValues>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetServiceBookingDropdowns?dropdownFor=` + DropdownFor,
            method: "GET"
        });
        return result;
    }

    public static async UpdateServiceBooking(svcBooking: IServiceBooking): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/UpdateServiceBookingWithFacility`,
            method: "PUT",
            data: svcBooking
        });
        return result;
    }
    //GET UpComming and Completed Service List for MyRecentBooking Menu
    public static async GetServiceBookingList(UserId): Promise<Result<Array<IUpcommingAndCompletedServices>>> {
        var result = await this.requestJson<Array<IUpcommingAndCompletedServices>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetServiceBookingList?UserId=` + UserId,
            method: "GET"
        });
        return result;
    }

    public static async GetQuickBookingList(): Promise<Result<Array<IServiceBooking>>> {
        var result = await this.requestJson<Array<IServiceBooking>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetQuickBookingList`,
            method: "GET"
        });
        return result;
    }

    public static async RegisterForClass(registration: IEventRegistration): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/RegisterForClass`,
            method: "PUT",
            data: registration
        });
        return result;
    }

    public static async GetTempleTimings(): Promise<Result<Array<ITempleTimes>>> {
        var result = await this.requestJson<Array<ITempleTimes>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleTimings`,
            method: "GET"
        });
        return result;
    }
    public static async GetHomePageContent(UserId: number): Promise<Result<Array<IHomePageContent>>> {
        var result = await this.requestJson<Array<IHomePageContent>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetHomePageContent?UserId=` + UserId,
            method: "GET"
        });
        return result;
    }

    public static async GetFacilityRequired(): Promise<Result<Array<IFacilityRequired>>> {
        var result = await this.requestJson<Array<IFacilityRequired>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetFacilities`,
            method: "GET"
        });
        return result;
    }

    public static async GetTempleServicesContent(): Promise<Result<Array<ITempleServicesContent>>> {
        var result = await this.requestJson<Array<ITempleServicesContent>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleServicesContent`,
            method: "GET"
        });
        return result;
    }

    public static async GetTempleServicesMaterialList(serviceId: number): Promise<Result<Array<IServiceMaterials>>> {
        var result = await this.requestJson<Array<IServiceMaterials>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleServicesMaterialList?serviceId=` + serviceId,
            method: "GET"
        });
        return result;
    }

    public static async GetTempleDeityDetails(godId): Promise<Result<any>> {
        var result = await this.requestJson<any>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleDeityDetails?godid=` + godId,
            method: "GET"
        });
        return result;
    }

    public static async GetTempleEventDetails(eventId): Promise<Result<any>> {
        var result = await this.requestJson<any>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleEventDetails?eventId=` + eventId,
            method: "GET"
        });
        return result;
    }

    public static async GetPriestSchedule(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetPriestSchedule`,
            method: "GET"
        });
        return result;
    }
    public static async TempleGallery(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleImages`,
            method: "GET"
        });
        return result;
    }

    public static async GetDeityList(): Promise<Result<Array<IDeity>>> {
        var result = await this.requestJson<Array<IDeity>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetDeityList`,
            method: "GET"
        });
        return result;
    }

    public static async PrintContentAsPdf(htmlContent: any): Promise<Result<any>> {
        var result = await this.requestJson<any>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/ConvertHTMLToPDF?htmlContent=` + htmlContent,
            method: "GET"
        });
        return result;
    }

    public static async GetProjectsAndAchievements(): Promise<Result<any>> {
        var result = await this.requestJson<any>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetProjectsAndAchievements`,
            method: "GET"
        });
        return result;
    }
    public static async GetPriestsDetails(): Promise<Result<Array<IPriest>>> {
        var result = await this.requestJson<Array<IPriest>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetPriestsDetails`,
            method: "GET"
        });
        return result;
    }

    public static async GetMissionAndVision(): Promise<Result<any>> {
        var result = await this.requestJson<any>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetMissionAndVision`,
            method: "GET"
        });
        return result;
    }

    public static async DevoteeRegistration(user: IDevoteeRegistration): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/DevoteeRegistration`,
            method: "PUT",
            data: user
        });
        return result;
    }

    public static async GetBoardMembers(): Promise<Result<Array<IBoardMembers>>> {
        var result = await this.requestJson<Array<IBoardMembers>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetBoardMembers`,
            method: "GET"
        });
        return result;
    }

    public static async VolunteerRegistration(user: IDevoteeRegistration): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/VolunteerRegistration`,
            method: "PUT",
            data: user
        });
        return result;
    }

    public static async DevoteeFeedbacks(user: IDevoteeFeedback): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/DevoteeFeedbacks`,
            method: "PUT",
            data: user
        });
        return result;
    }

    // public static async GetProjectsList (): Promise<Result<IProjectsAndAchievements>>{
    //     var result = await this.requestJson<IProjectsAndAchievements>({
    //         url: process.env.REACT_APP_TempleAPI+`TempleServices/GetProjects`,
    //         method: "GET"
    //     });
    //     return result;
    // }  


    public static async GetProjectsList(): Promise<Result<any>> {
        var result = await this.requestJson<any>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetProjectsAndAchievements`,
            method: "GET"
        });
        return result;
    }
    // public static async GetProjectsList (): Promise<Result<any>> {           
    //     var result = await this.requestJson<any>({
    //         url: process.env.REACT_APP_TempleAPI+`TempleServices/GetProjects`,
    //         method: "GET"
    //     });
    //     return result;
    // }  
    public static async GetTempleFiles(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleFiles`,
            method: "GET"
        });
        return result;
    }
    public static async GetDetailProfileInfo(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetDetailProfileInfo`,
            method: "GET"
        });
        return result;
    }

    public static async AddOrUpdateDetailProfileInfo(Detail: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/AddOrUpdateDetailProfileInfo`,
            method: "PUT",
            data: Detail
        });
        return result;
    }
    public static async GetBajanList(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleBajenGodsFiles`,
            method: "GET"
        });
        return result;
    }
    public static async GetIndividualBajans(BajenId): Promise<Result<any>> {
        var result = await this.requestJson<any>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleBajenGodsFiles?BajenId=` + BajenId,
            method: "GET"
        });
        return result;
    }
    public static async GetFamilyDetails(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetFamilyDetailSpecialDayInfo`,
            method: "GET"
        });
        return result;

    }
    public static async PutFamilyDetails(FamilyDetail: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/AddOrUpdateFamilyDetailSpecialDayInfo`,
            method: "PUT",
            data: FamilyDetail
        });
        return result;
    }

    public static async GetAdminServiceList(): Promise<Result<Array<IAdminService>>> {
        var result = await this.requestJson<Array<IAdminService>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetServices`,
            method: "GET"
        });
        return result;
    }

    public static async AddOrUpdateAdminService(user: IAdminService): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/AddUpdateService`,
            method: "PUT",
            data: user
        });
        return result;
    }

    public static async GetAdminTempleTimingSearchResult(session, startDate, endDate): Promise<Result<Array<IAdminService>>> {
        var result = await this.requestJson<Array<IAdminService>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetTempleTimings?Session=` + session + `&StartDate=` + startDate + `&EndDate=` + endDate,
            method: "GET"
        });
        return result;
    }

    public static async GetAdminPriestList(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetPriestList`,
            method: "GET"
        });
        return result;
    }
    public static async UpdateCalender(cal: ICalendar): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/UpdateCalender`,
            method: "PUT",
            data: cal
        });
        return result;
    }

    public static async GetWebContent(screenName): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetWebContent?ScreenName=` + screenName,
            method: "GET"
        });
        return result;
    }

    public static async UpdateWebContent(content): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/UpdateWebContent`,
            method: "PUT",
            data: content
        });
        return result;
    }
    public static async GetPriestProfileDetails(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetPriestList`,
            method: "GET"
        });
        return result;

    }
    public static async PutPriestProfileDetails(PriestProfile: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/AddOrUpdatePriestInfo`,
            method: "PUT",
            data: PriestProfile
        });
        return result;
    }
    public static async GetEventDetails(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetEventHeaders`,
            method: "GET"
        });
        return result;

    }
    public static async PutEventDetails(Eventprofile: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/AddUpdateEventHeader`,
            method: "PUT",
            data: Eventprofile
        });
        return result;
    }
    public static async GetHinduGods(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetHinduGods`,
            method: "GET"
        });
        return result;
    }
    public static async GetImageGalleryAdmin(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetImageGallery`,
            method: "GET"
        });
        return result;
    }
    public static async UpdateImageGallery(ImageGalleryAdmin: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/InsertOrUpdateTempleImages`,
            method: "PUT",
            data: ImageGalleryAdmin
        });
        return result;
    }
    public static async GetFilesAdmin(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetTempleFiles`,
            method: "GET"
        });
        return result;
    }
    public static async UpdateFilesDetails(FileDetailAdmin: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/InsertOrUpdateTempleFiles`,
            method: "PUT",
            data: FileDetailAdmin
        });
        return result;
    }

    public static async GetPriestSheduleList(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetPriestScheduleHeader`,
            method: "GET"
        });
        return result;
    }

    public static async GetEventTypeDropdownValue(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetEventType`,
            method: "GET"
        });
        return result;
    }

    public static async GetServiceModeDropdownValue(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetServiceMode`,
            method: "GET"
        });
        return result;
    }
    public static async GetBoardMembersAdmin(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetBoardMembers`,
            method: "GET"
        });
        return result;
    }
    public static async GetUsertypeBoardMembers(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetUserType`,
            method: "GET"
        });
        return result;
    }
    public static async UpdateBoardMembersDetails(BoardMembersDetails: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/AddOrUpdateBoardMembersInfo`,
            method: "PUT",
            data: BoardMembersDetails
        });
        return result;
    }
    public static async UpdateHinduGods(AdminHinduGods: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/AddOrUpdateHinduGodsInfo`,
            method: "PUT",
            data: AdminHinduGods
        });
        return result;
    }

    public static async AddOrUpdatePriestShedule(data): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/AddUpdatePriestScheduleHeader`,
            method: "PUT",
            data: data
        });
        return result;
    }
    public static async GetLatestNews(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetWebContent?ScreenName=LatestNews`,
            method: "GET"
        });
        return result;
    }
    public static async UpdateLatesNews(LatestNewsUpdate: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/UpdateWebContent`,
            method: "PUT",
            data: LatestNewsUpdate
        });
        return result;
    }
    public static async GetAdminSlider(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetSlidersContent`,
            method: "GET"
        });
        return result;
    }
    public static async UpdateAdminSlider(SliderUpdate: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/InsertOrUpdateSlidersContent`,
            method: "PUT",
            data: SliderUpdate
        });
        return result;
    }

    public static async GetServiceBooking(ServiceBookingId, UserId, ApproverId): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetServiceBooking?ServiceBookingId=` + ServiceBookingId + `&UserId=` + UserId + `&ApproverId=` + ApproverId,
            method: "GET"
        });
        return result;
    }
    public static async SeriviceBookingApproval(data: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/UpdateServiceBookingStatus`,
            method: "PUT",
            data: data
        });
        return result;
    }

    public static async GetAdminAnnualSubscription(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetAnnualSubscription`,
            method: "GET"
        });
        return result;
    }

    public static async PutAdminAnnualSubscription(FileDetailAdmin: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/InsertOrUpdateAnnualSubscription`,
            method: "PUT",
            data: FileDetailAdmin
        });
        return result;
    }

    public static async GetStateData(): Promise<Result<Array<IStateData>>> {
        var result = await this.requestJson<Array<IStateData>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetStateData`,
            method: "GET"
        });
        return result;
    }
    public static async GetStateEventDetails(stateId): Promise<Result<any>> {
        var result = await this.requestJson<any>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetStateEventDetails?stateId=` + stateId,
            method: "GET"
        });
        return result;
    }
    public static async GetCalender(Month): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetCalenderInfo?Month=` + Month,
            method: "GET"
        });
        return result;
    }
    public static async GetFacilityAddlCost(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetFacilityAddtionalCost`,
            method: "GET"
        });
        return result;
    }
    public static async CheckForOldUser(email): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/CheckForOldUser?email=` + email,
            method: "GET"
        });
        return result;
    }
    public static async GetTempleFacilityCalender(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleFacilityCalender`,
            method: "GET"
        });
        return result;
    }
    public static async GetTempleFacilityCalenderAvail(startDate, endDate): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleFacilityCalender?StartDate=` + startDate + `&EndDate=` + endDate,
            method: "GET"
        });
        return result;
    }

    public static async GetPriestScheduleCalander(PriestId, StartDate, EndDate): Promise<Result<any>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetPriestScheduleCalander?PriestId=` + PriestId + `&StartDate=` + StartDate + `&EndDate=` + EndDate,
            method: "GET"
        });
        return result;
    }
    public static async GetPriestScheduleCalanderWOParams(): Promise<Result<any>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetPriestScheduleCalander`,
            method: "GET"
        });
        return result;
    }

    public static async GetMyPendingRequest(UserId): Promise<Result<any>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetMyPendingRequest?userId=` + UserId,
            method: "GET"
        });
        return result;
    }

    public static async GetTempleRequiredItems(): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetTempleRequiredItems?`,
            method: "GET"
        });
        return result;
    }
    public static async GetVolunteerRequirementList(UserId): Promise<Result<any>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetVolunteerRequirementList?UserId=` + UserId,
            method: "GET"
        });
        return result;
    }
    public static async PutVolunteerRequirementList(VolunteerRequirementList: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/InsertVolunteerRequirement`,
            method: "PUT",
            data: VolunteerRequirementList
        });
        return result;
    }
    public static async UpdateByVolunteer(volunteerUpdate: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/InsertVolunteerUserId`,
            method: "PUT",
            data: volunteerUpdate
        });
        return result;
    }
    public static async InsertTempleRequiredItems(TempleRequiredItems: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/InsertTempleRequiredItems`,
            method: "PUT",
            data: TempleRequiredItems
        });
        return result;
    }
    public static async GetInterstedVolunteerRequirements(UserId): Promise<Result<any>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetInterstedVolunteerRequirements?UserId=` + UserId,
            method: "GET"
        });
        return result;
    }

    public static async DeleteServiceBooking(ServiceBookingId, UserId): Promise<Result<any>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/DeleteServiceBooking?ServiceBookingId=` + ServiceBookingId + `&UserId=` + UserId,
            method: "GET"
        });
        return result;
    }

    public static async UploadEventsList(Events: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/UploadEventsList`,
            method: "PUT",
            data: Events
        });
        return result;
    }
    public static async CancelServiceBooking(ServiceBookingId: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/CancelServiceBooking?ServiceBookingId=` + ServiceBookingId,
            method: "PUT",
            data: ServiceBookingId
        });
        return result;
    }

    public static async GetAllMenus(): Promise<Result<any>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetAllMenus`,
            method: "GET"
        });
        return result;
    }
    public static async GetUserLevelMenus(UsertypeId: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetUserLevelMenus?UserType=` + UsertypeId,
            method: "GET",
        });
        return result;
    }
    public static async UpdateMenuAccess(ServiceBookingId: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/UpdateMenuAccess`,
            method: "PUT",
            data: ServiceBookingId
        });
        return result;
    }

    public static async GetMultipleServiceBooking(ServiceBookingId, UserId, ApproverId): Promise<Result<Array<any>>> {
        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAdminAPI + `TempleService/GetMultipleServiceBooking?ServiceBookingId=` + ServiceBookingId + `&UserId=` + UserId + `&ApproverId=` + ApproverId,
            method: "GET"
        });
        return result;
    }
    public static async GetEventSlot(): Promise<Result<Array<any>>> {

        var result = await this.requestJson<Array<any>>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/GetEventSlots`,
            method: "GET"
        });
        return result;
    }
    public static async UpdateEventslot(EventSlotId: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/AddOrUpdateEventSlot`,
            method: "PUT",
            data: EventSlotId
        });
        return result;
    }
    public static async BookEventslot(EventSlotId: any): Promise<Result<IAPIResponse>> {
        var result = await this.requestJson<IAPIResponse>({
            url: process.env.REACT_APP_TempleAPI + `TempleServices/BookSlots`,
            method: "PUT",
            data: EventSlotId
        });
        return result;
    }

}

